<template>
  <gh-table-page ref="table" :tabs="tabs" :args-query="args" module="dynamic_cls" :cls="cls" sort-by="Seq"
    @start-query="" :before-save="beforeSave" @save-after="$refs.tree.query()" delete-after="$refs.tree.query()">
    <template #area_left>
      <gh-business-tree default-expand-all ref="tree" v-model="parent" module="dynamic_cls" :cls="cls"
        :attached-all="true">
        <template v-slot="{node,data}">
          {{data.Cd}}{{data.Name}}<v-icon> {{data.icon}}</v-icon>

        </template>
      </gh-business-tree>
    </template>
    <template #area_query>
      <v-layout row align-center>
        <v-flex>
          <v-text-field v-model="args.keyword" counter :autofocus="true" clearable label="关键字"
            append-icon="mdi-circle-edit-outline" @change="$refs.table.query()">
          </v-text-field>
        </v-flex>
      </v-layout>
    </template>
  </gh-table-page>
</template>
<style scoped>

</style>

<script>
  import TreePage from "./treePage.ts";
  export default TreePage;
</script>